var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErfrischenderPolarCleanDuft = function SvgErfrischenderPolarCleanDuft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Erfrischender_Polar_Clean_Duft__svg__Ebene_2",
    viewBox: "0 0 91.73 91.73"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Erfrischender_Polar_Clean_Duft__svg__cls-2{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Erfrischender_Polar_Clean_Duft__svg__Layer_1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.71 19.93C40.29 19 14.3 45.5 31.43 63.04c16.97 13.1 38.98-6.68 36.28-43.11M56.54 33.49 23.79 72.93",
    className: "Erfrischender_Polar_Clean_Duft__svg__cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m37.4 42.46 1.17 12.68 12.96-1.31M47.46 35.45l1.56 7.11 7.51-.49",
    className: "Erfrischender_Polar_Clean_Duft__svg__cls-2"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 45.87,
    cy: 45.87,
    r: 44.62,
    style: {
      strokeMiterlimit: 10,
      strokeWidth: "2.5px",
      fill: "none",
      stroke: "currentColor"
    }
  })));
};
export default SvgErfrischenderPolarCleanDuft;